import React from 'react';

import logo from '../../assets/logo/logo.svg';

import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';

const StyledHeader = styled(Stack)(({ theme }) => ({
	backgroundColor: theme.palette.background
}));

const Header = () => {
	return (
		<StyledHeader py={2} px={4}>
			<img src={logo} alt='rizzbates' width='170px' />
		</StyledHeader>
	);
};

export default Header;
